import styled from 'styled-components';

export const HistoryContainer = styled.div`
    margin: 15px;
`

export const HistoryCard = styled.ul`
    list-style: none;
    background-color: ${({theme}) => theme.colors.primary};
    padding: 10px;
    min-height: 80vh;
`

export const HistoryList = styled.li`
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    border: 1px solid rgba(255, 255, 255, 0.2);
    margin-block: 10px;
    padding: 10px;
`